export const PHONE_ERROR_TEXT = {
    empty: "Укажите номер телефона.",
    default: "Пожалуйста, введите корректный номер телефона.",
}
